module.exports = __webpack_public_path__ + "img/q4-opt-b.a1751ab8.png";